import React, { useState } from "react";
import { Navbar, Nav, Button, Modal, Container } from "react-bootstrap";

import logo from "../assets/logo.jpg";
import "../Styles/NavbarSection.css";

import Member from "../components/Membership/Member";
import HRLogin from "../components/HrDashBoard/HrLogin";
import StudentLogin from "../components/Student/StudentLogin";
import AdminLogin from "../components/Login";

const NavbarSection = () => {
  // =========================================================
  // MEMBERSHIP MODAL
  // =========================================================

  const [showMember, setShowMember] = useState(false);

  const handleShowMember = () => {
    setShowMember(true);
  };

  const handleCloseMember = () => {
    setShowMember(false);
  };

  // =========================================================
  // LOGIN MODAL
  // =========================================================

  const [showLoginDropDown, setShowLoginDropDown] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [selectedLoginType, setSelectedLoginType] = useState(null);

  // Open login dropdown
  const handleLoginClick = () => {
    setShowLoginDropDown((prev) => !prev);
  };

  // Open login modal
  const openLoginModal = (type) => {
    setSelectedLoginType(type);
    setShowLogin(true);
    setShowLoginDropDown(false);
  };

  // Close login modal
  const handleCloseLogin = () => {
    setShowLogin(false);
    setSelectedLoginType(null);
  };

  return (
    <>
      {/* =========================================================
          NAVBAR
      ========================================================= */}

      <Navbar expand="lg" className="custom-navbar">
        <Container fluid>

          {/* LOGO */}
          <Navbar.Brand href="/" className="navbar-brand">
            <img
              src={logo}
              alt="NHRC Logo"
            />
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            className="custom-toggle"
          />

          <Navbar.Collapse
            id="basic-navbar-nav"
            className="justify-content-between"
          >

            {/* =====================================================
                CENTER NAVIGATION
            ===================================================== */}

            <Nav className="navbar-center mx-auto">

              <Nav.Link
                href="#home"
                className="nav-link-custom fw-bold"
              >
                Home
              </Nav.Link>

              {/* ABOUT */}
              <div className="nav-item-with-dropdown">

                <Nav.Link
                  href="#about"
                  className="nav-link-custom fw-bold"
                >
                  About
                </Nav.Link>

                <div className="dropdown-hover-menu">

                  <a
                    href="#board-members"
                    className="dropdown-item-hover"
                  >
                    Board Members
                  </a>

                  <a
                    href="#member-benefits"
                    className="dropdown-item-hover"
                  >
                    Member Benefits
                  </a>

                </div>

              </div>

              {/* SERVICES */}
              <div className="nav-item-with-dropdown">

                <Nav.Link
                  href="#services"
                  className="nav-link-custom fw-bold"
                >
                  Services
                </Nav.Link>

                <div className="dropdown-hover-menu">

                  <a
                    href="#global"
                    className="dropdown-item-hover"
                  >
                    Global Networking
                  </a>

                  <a
                    href="#knowledge"
                    className="dropdown-item-hover"
                  >
                    Knowledge Sharing
                  </a>

                  <a
                    href="#UpdateSkills"
                    className="dropdown-item-hover"
                  >
                    Update Skills & Training
                  </a>

                  <a
                    href="#jobs"
                    className="dropdown-item-hover"
                  >
                    Jobs & Job Fairs
                  </a>

                  <a
                    href="#talant"
                    className="dropdown-item-hover"
                  >
                    Talent Publication
                  </a>

                </div>

              </div>

              <Nav.Link
                href="#current"
                className="nav-link-custom fw-bold"
              >
                Current Job
              </Nav.Link>

              <Nav.Link
                href="#events"
                className="nav-link-custom fw-bold"
              >
                CSR Events
              </Nav.Link>

              <Nav.Link
                href="#chapters"
                className="nav-link-custom fw-bold"
              >
                Chapters
              </Nav.Link>

              <Nav.Link
                href="#Blockprofile"
                className="nav-link-custom fw-bold"
              >
                Block Profile
              </Nav.Link>

              <Nav.Link
                href="#contact"
                className="nav-link-custom fw-bold"
              >
                Contact Us
              </Nav.Link>

            </Nav>

            {/* =====================================================
                RIGHT SIDE BUTTONS
            ===================================================== */}

            <div className="navbar-right">

              {/* MEMBERSHIP */}
              <Button
                variant="outline-success"
                className="btn-custom-green"
                onClick={handleShowMember}
              >
                MEMBERSHIP
              </Button>

              {/* LOGIN */}
              <div className="login-dropdown-container">

                <Button
                  variant="outline-danger"
                  className="btn-outline-danger-custom"
                  onClick={handleLoginClick}
                >
                  LOGIN
                </Button>

                {showLoginDropDown && (
                  <div className="login-dropdown">

                    <p
                      onClick={() =>
                        openLoginModal("admin")
                      }
                    >
                      Login as Admin
                    </p>

                    <p
                      onClick={() =>
                        openLoginModal("hr")
                      }
                    >
                      Login as HR
                    </p>

                    <p
                      onClick={() =>
                        openLoginModal("student")
                      }
                    >
                      Login as Student
                    </p>

                  </div>
                )}

              </div>

            </div>

          </Navbar.Collapse>

        </Container>
      </Navbar>

      {/* =========================================================
          MEMBERSHIP MODAL
      ========================================================= */}

      <Modal
        show={showMember}
        onHide={handleCloseMember}
        centered
        size="lg"
        backdrop="static"
        keyboard={true}
        className="membership-modal"
      >

        <Modal.Header
          closeButton
          className="border-0"
        >
          <Modal.Title className="fw-bold">
            {/* Membership Form */}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Member />
        </Modal.Body>

      </Modal>

      {/* =========================================================
          LOGIN MODAL
      ========================================================= */}

      <Modal
        show={showLogin}
        onHide={handleCloseLogin}
        centered
        backdrop="static"
        keyboard={true}
        className="login-modal"
        dialogClassName="login-modal-dialog"
      >

        {/* =====================================================
            MODAL HEADER
            CLOSE BUTTON IS HERE
        ===================================================== */}

        <Modal.Header
          closeButton
          className="login-modal-header"
        >

          <Modal.Title className="login-modal-title">
            {selectedLoginType === "admin"
              ? "Admin Login"
              : selectedLoginType === "hr"
              ? "HR Login"
              : selectedLoginType === "student"
              ? "Student Login"
              : "Login"}
          </Modal.Title>

        </Modal.Header>

        {/* =====================================================
            LOGIN BODY
        ===================================================== */}

        <Modal.Body className="login-modal-body">

          {selectedLoginType === "admin" && (
            <AdminLogin />
          )}

          {selectedLoginType === "hr" && (
            <HRLogin />
          )}

          {selectedLoginType === "student" && (
            <StudentLogin />
          )}

        </Modal.Body>

      </Modal>
    </>
  );
};

export default NavbarSection;